<template>
  <LayoutDefault>
    <section class="materials">
      <div class="materials__tab">
        <BaseBtn
          @click="switchTab(1)"
          :active="activeTab === 1"
          white
          text="Статьи"
        />
        <BaseBtn
          @click="switchTab(2)"
          :active="activeTab === 2"
          white
          text="Полезные ссылки"
        />
        <BaseBtn
          @click="switchTab(3)"
          :active="activeTab === 3"
          white
          text="Гостиницы Саратова"
        />
      </div>
      <MaterisalsArticles v-if="activeTab === 1"/>
      <MaterialsLinks v-if="activeTab === 2"/>
      <MaterialsHostelsTable :data="dataSource"  v-if="activeTab === 3"/>
    </section>
  </LayoutDefault>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import MaterisalsArticles from '@/components/blocks/MaterisalsArticles.vue'
import MaterialsLinks from '@/components/blocks/MaterialsLinks.vue'
import MaterialsHostelsTable from '@/components/blocks/MaterialsHostelsTable.vue'

export default {
  name: 'MaterialsEducationView',
  components: {
    LayoutDefault,
    BaseBtn,
    MaterisalsArticles,
    MaterialsLinks,
    MaterialsHostelsTable
  },
  props: {
  },
  setup () {
    const store = useStore()

    const activeTab = computed(() => {
      return store.getters.getActiveTab
    })

    const switchTab = (val) => {
      store.commit('SetActiveTab', val)
    }

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    return {
      activeTab,
      switchTab,
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.materials {

  &__tab {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
  }

  :deep(.active) {
    pointer-events: none;
  }
}
</style>
